var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-brand',[_c('b',{staticClass:"logo-icon"},[_c('img',{attrs:{"src":require("../../../assets/images/logo-light-icon-softbusiness.png"),"alt":"homepage"}})]),_c('span',{staticClass:"logo-text ml-2"},[_c('img',{attrs:{"src":require("../../../assets/images/logo-light-text-softbusiness.png"),"alt":"homepage"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }